// extracted by mini-css-extract-plugin
export default {"card":"TrialCard_card__kHPRK","closeButton":"TrialCard_closeButton__DU9oV","info":"TrialCard_info__asoY6"};